module.exports = __webpack_public_path__ + "img/cockpit.d2b20a68.png";